import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'
const routes = [
  route('index', '/index', DashboardProfessional, meta('Dashboard Estabelecimento', true, 'guest'))
]

export default subGroup('/dashboard/company', routes)



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/routes.js